/**
 * Property reducer
 *
 * @author Anh Tu Le <anh.le@vertics.co>
 *
 * @copyright Vertics Co 2019
 */
import {
    USER_GET_USERS,
    USER_GET_USERS_SUCCESS,
    USER_GET_USERS_FAIL,
    USERS_GET_SELECTED_USER,
    USERS_DELETE_USER,
    USERS_DELETE_USER_SUCCESS,
    USERS_DELETE_USER_FAIL

} from './../actions'
const initialState = {
    users: [],
    entriesCount: 0,
    pageNumber: 1,
    selectedUser: null,
    loading: false,
    error: null
}
export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case USERS_GET_SELECTED_USER:
            return {
                ...state,
                selectedUser: action.user
            }
            case USER_GET_USERS:
                return {
                    ...state,
                    loading: true,
                }
                case USER_GET_USERS_SUCCESS:
                    const {
                        results, entriesCount, pageNumber
                    } = action.payload.data
                    return {
                        ...state,
                        loading: false,
                            users: results,
                            entriesCount,
                            pageNumber
                    }
                    case USER_GET_USERS_FAIL:
                        return {
                            ...state,
                            loading: false,
                                properties: action.payload&&action.payload.data.results,
                                entriesCount: action.payload&&action.payload.data.entriesCount
                        }
                        case USERS_DELETE_USER:
                            return {
                                ...state, loading: true
                            }
                            case USERS_DELETE_USER_SUCCESS:
                                return {
                                    ...state, loading: false
                                }
                                case USERS_DELETE_USER_FAIL:
                                    return {
                                        ...state, loading: false
                                    }
                                    default:
                                        return state
    }
}
export const usersSelectors = {
    getPageNumber: (state = initialState) => state.pageNumber,
    getEntriesCount: (state = initialState) => state.entriesCount,
    getSelectedUser: (state = initialState) => state.selectedUser,
    getUsers: (state = initialState) => state.users,
    getLoading: (state = initialState) => state.loading,
    getError: (state = initialState) => state.error
}